import type { Form } from '#ui/types'
import type { Ref } from 'vue'
import { z } from 'zod'

export const useNuxtUiFormRepeat = <T extends z.ZodRawShape>(params: {
  form: Ref<Form<any> | undefined, Form<any> | undefined>
  state: any
  schema: z.ZodObject<T>
  parentFieldName: string
  repeatFieldName: string
  message?: string
}): z.ZodObject<T> => {
  const checkEmailRepeat = async () => {
    if (
      params.state[params.parentFieldName] !== undefined &&
      params.state[params.repeatFieldName] !== undefined
    ) {
      try {
        if (params.form !== undefined && params.form.value !== undefined) {
          await params.form.value.validate(params.repeatFieldName)
        }
      } catch {
        console.log('form invalid')
      }
    }
  }

  watch(() => params.state[params.parentFieldName], checkEmailRepeat)

  const schemaExtended = params.schema.extend({
    [params.repeatFieldName]: z
      .string()
      .refine(
        () =>
          params.state[params.repeatFieldName] ===
          params.state[params.parentFieldName],
        {
          message: params.message
            ? params.message
            : t('zodI18nCustom.generic_repeat'),
        },
      ),
  })

  return schemaExtended as any
}
